module.exports = __webpack_public_path__ + "img/workspace-onboarding/install-desktop-app-rebrand-6ade02435cb1d4d790eed941981d0023.png";